import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
import { ResultComponent } from 'projects/app-default/src/app/ui/resut/result.component';
import { ProductViewAddToBasketComponent } from '../../product-view-add-to-basket/product-view-add-to-basket.component';
@Component({
    selector: 'product-bundle-options-add-to-basket',
    templateUrl: 'product-bundle-options-add-to-basket.component.html',
    standalone: true,
    imports: [ActionComponent, ResultComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductBundleOptionsAddToBasketComponent extends ProductViewAddToBasketComponent {}
